import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { CircularProgress, Box, Typography, keyframes } from "@mui/material";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectAuthLoading } from "../store/slices/authSlice";
import HyrvixLogo from "./HyrvixLogo";

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.5; }
`;

export default function ProtectedRoute() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);

  // Show loading only on initial app load (user state unknown).
  // If user is already authenticated, keep rendering the child route even while
  // checkAuth() re-fetches — prevents Dashboard unmounting on credit refreshes.
  if (loading && !isAuthenticated) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="#f8fafc"
        gap={2}
      >
        <Box sx={{ animation: `${pulse} 1.4s ease-in-out infinite` }}>
          <HyrvixLogo size={48} />
        </Box>
        <CircularProgress size={20} sx={{ color: "#2563eb" }} />
        <Typography variant="caption" sx={{ color: "#94a3b8", fontWeight: 500 }}>
          Loading…
        </Typography>
      </Box>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
